import { LocalExameModel } from "./local-exame.model";
import { UnidadeDetranModel } from "./unidade-detran.model";

export class LocalModel {

  localExame?: LocalExameModel[];
  id?: number;
  codigoLocalDetran?: number;
  idUnidadeDetran?: number;
  descricao?: string;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  ativo?: boolean;
  listaLocalExames?: string;
  unidadeDetran?: UnidadeDetranModel;

  constructor(options: LocalModel = {}) {
    this.localExame = options.localExame || new Array<LocalExameModel>();
    this.id = options.id || null;
    this.codigoLocalDetran = options.codigoLocalDetran || null;
    this.idUnidadeDetran = options.idUnidadeDetran || null;
    this.descricao = options.descricao || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.ativo = options.ativo || null;
    this.listaLocalExames = options.listaLocalExames || null;
    this.unidadeDetran = options.unidadeDetran || new UnidadeDetranModel();

  }
}
